import { type FormEvent, useState } from "react";
import { Link } from "react-router";

import { type BatchRow, listBatches, message } from "./releaseClient";

/** The release batches of an engagement. */
export function ReleaseCenterPage() {
  const [batches, setBatches] = useState<BatchRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  function onFind(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const engagement = String(new FormData(event.currentTarget).get("engagement") ?? "").trim();
    listBatches(engagement)
      .then((found) => {
        setBatches(found);
        setError(null);
      })
      .catch((caught: unknown) => setError(message(caught)));
  }

  return (
    <section aria-labelledby="release-title">
      <h1 id="release-title">Release center</h1>
      <form onSubmit={onFind} aria-label="Find batches">
        <label>
          Engagement id <input name="engagement" required />
        </label>
        <button type="submit">Show batches</button>
      </form>
      {error && <p role="alert">Could not load: {error}</p>}
      {batches?.length === 0 && <p>This engagement has no release batches.</p>}
      {batches && batches.length > 0 && (
        <ul aria-label="Batches">
          {batches.map((batch) => (
            <li key={batch.id}>
              <Link to={`/release-center/${batch.id}`}>{batch.batch_key}</Link>: {batch.release_state},{" "}
              {batch.item_count ?? "unknown"} items, for {batch.purpose}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
